import React from 'react';

export function AppsIcon({ width = 28, height = 24, stroke = "currentColor" }) {
  return (
    <svg width={width} height={height} viewBox="0 0 25 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.4791 0.525024H0.520752V20.475H24.4791V0.525024Z" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
      <path d="M24.4791 4.72504H0.520752" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
      <path d="M20.3125 2.625H18.75" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
      <path d="M22.9165 2.625H21.354" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
      <path d="M17.7083 2.625H16.1458" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
      <path d="M11.4583 2.625H2.08325" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
      <path d="M4.6875 8.92505L8.33333 12.6L4.6875 16.275" stroke={stroke} strokeWidth={2} strokeMiterlimit={10} />
    </svg>
  );
}

export const APPF_appsIcon = <AppsIcon />


export const APPF_radarIcon =
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32px"
    height="32px"
    version="1.1"
    viewBox="0 0 542 542"
    xmlSpace="preserve"
  >
    <path
      style={{ fill: "#294C22" }}
      d="M248.403,0.648C111.392,0.648,0.321,111.708,0.321,248.73c0,137.001,111.07,248.07,248.082,248.07
c137.006,0,248.076-111.069,248.076-248.07C496.48,111.707,385.41,0.648,248.403,0.648z"
    />
    <path
      style={{ fill: "#3A682E" }}
      d="M496.464,249.984c0.002-0.419,0.016-0.834,0.016-1.254c0-0.257-0.009-0.512-0.01-0.769h-14.612
v-44.477h10.493c-0.125-0.676-0.258-1.349-0.388-2.022h-10.105v-36.81c-0.646-1.794-1.313-3.577-2-5.351v42.161h-44.5v-44.489
h43.593c-0.268-0.669-0.545-1.333-0.817-2h-42.775v-44.5h19.052c-0.451-0.671-0.913-1.333-1.371-2h-17.681V85.667
c-0.661-0.757-1.33-1.505-2-2.254v25.059h-44.5v-44.5h25.085c-0.748-0.67-1.498-1.338-2.254-2h-22.831V44.229
c-0.667-0.459-1.328-0.925-2-1.378v19.121h-44.5V19.077c-0.667-0.273-1.331-0.55-2-0.817v43.713h-44.49v-44.5h42.494
c-1.761-0.685-3.529-1.354-5.309-2h-37.186V5.203c-0.673-0.13-1.345-0.262-2.02-0.387v10.657h-44.48V0.66
c-0.322-0.001-0.642-0.012-0.964-0.012c-0.354,0-0.703,0.012-1.056,0.013v14.812h-44.48V4.833c-0.675,0.125-1.347,0.256-2.02,0.387
v10.252H163.75c-1.779,0.646-3.549,1.315-5.309,2h42.405v44.5h-44.49V18.296c-0.669,0.268-1.334,0.544-2,0.817v42.86h-44.5V42.909
c-0.672,0.453-1.333,0.921-2,1.38v17.683H85.114c-0.756,0.662-1.506,1.33-2.254,2h24.998v44.5h-44.5V83.511
c-0.669,0.749-1.34,1.497-2,2.254v22.708H43.763c-0.457,0.667-0.92,1.329-1.371,2h18.966v44.5H18.669
c-0.272,0.667-0.55,1.331-0.817,2h43.507v44.489h-44.5v-41.935c-0.687,1.78-1.354,3.569-2,5.369v36.565H4.839
c-0.13,0.674-0.263,1.347-0.388,2.022h10.407v44.478H0.332c-0.001,0.257-0.01,0.512-0.01,0.769c0,0.419,0.014,0.835,0.016,1.254
h14.521v44.478H4.546c0.126,0.675,0.256,1.349,0.388,2.022h9.925v36.07c0.646,1.799,1.313,3.588,2,5.368v-41.438h44.5v44.478h-43.31
c0.271,0.676,0.55,1.349,0.826,2.022h42.482v44.478H42.714c0.46,0.68,0.936,1.347,1.402,2.022h17.241v22.197
c0.66,0.757,1.331,1.505,2,2.254v-24.451h44.5v44.489H83.423c0.749,0.668,1.495,1.341,2.254,2h22.181v17.184
c0.667,0.459,1.328,0.927,2,1.38v-18.564h44.5v42.361c0.666,0.273,1.331,0.55,2,0.817v-43.179h44.49v44.5h-41.095
c1.794,0.687,3.598,1.354,5.412,2h35.683v9.755c0.673,0.13,1.345,0.262,2.02,0.387v-10.142h44.48v14.314
c0.353,0.001,0.702,0.013,1.056,0.013c0.322,0,0.642-0.011,0.964-0.012v-14.315h44.48v10.16c0.675-0.125,1.347-0.257,2.02-0.387
v-9.772h35.771c1.814-0.646,3.618-1.313,5.412-2h-41.184v-44.5h44.49v43.215c0.669-0.267,1.333-0.544,2-0.817v-42.397h44.5v18.622
c0.672-0.453,1.333-0.919,2-1.378v-17.244h22.269c0.758-0.659,1.504-1.332,2.254-2h-24.522v-44.49h44.5v24.548
c0.67-0.749,1.339-1.497,2-2.254v-22.294h17.327c0.467-0.675,0.943-1.343,1.402-2.022h-18.729v-44.478h42.568
c0.276-0.673,0.556-1.346,0.826-2.022h-43.395v-44.478h44.5v41.665c0.687-1.774,1.354-3.557,2-5.351v-36.314h10.011
c0.132-0.673,0.262-1.347,0.388-2.022h-10.398v-44.478H496.464z M61.358,294.461h-44.5v-44.477h44.5V294.461z M61.358,247.961h-44.5
v-44.477h44.5V247.961z M107.858,387.461h-44.5v-44.477h44.5V387.461z M107.858,340.961h-44.5v-44.477h44.5V340.961z
M107.858,294.461h-44.5v-44.477h44.5V294.461z M107.858,247.961h-44.5v-44.477h44.5V247.961z M107.858,201.461h-44.5v-44.489h44.5
V201.461z M107.858,154.973h-44.5v-44.5h44.5V154.973z M154.357,433.973h-44.5v-44.489h44.5V433.973z M154.357,387.461h-44.5
v-44.477h44.5V387.461z M154.357,340.961h-44.5v-44.477h44.5V340.961z M154.357,294.461h-44.5v-44.477h44.5V294.461z
M154.357,247.961h-44.5v-44.477h44.5V247.961z M154.357,201.461h-44.5v-44.489h44.5V201.461z M154.357,154.973h-44.5v-44.5h44.5
V154.973z M154.357,108.473h-44.5v-44.5h44.5V108.473z M200.848,433.973h-44.49v-44.489h44.49V433.973z M200.848,387.461h-44.49
v-44.477h44.49V387.461z M200.848,340.961h-44.49v-44.477h44.49V340.961z M200.848,294.461h-44.49v-44.477h44.49V294.461z
M200.848,247.961h-44.49v-44.477h44.49V247.961z M200.848,201.461h-44.49v-44.489h44.49V201.461z M200.848,154.973h-44.49v-44.5
h44.49V154.973z M200.848,108.473h-44.49v-44.5h44.49V108.473z M247.348,480.473h-44.48v-44.5h44.48V480.473z M247.348,433.973
h-44.48v-44.489h44.48V433.973z M247.348,387.461h-44.48v-44.477h44.48V387.461z M247.348,340.961h-44.48v-44.477h44.48V340.961z
M247.348,294.461h-44.48v-44.477h44.48V294.461z M247.348,247.961h-44.48v-44.477h44.48V247.961z M247.348,201.461h-44.48v-44.489
h44.48V201.461z M247.348,154.973h-44.48v-44.5h44.48V154.973z M247.348,108.473h-44.48v-44.5h44.48V108.473z M247.348,61.973
h-44.48v-44.5h44.48V61.973z M293.848,480.473h-44.48v-44.5h44.48V480.473z M293.848,433.973h-44.48v-44.489h44.48V433.973z
M293.848,387.461h-44.48v-44.477h44.48V387.461z M293.848,340.961h-44.48v-44.477h44.48V340.961z M293.848,294.461h-44.48v-44.477
h44.48V294.461z M293.848,247.961h-44.48v-44.477h44.48V247.961z M293.848,201.461h-44.48v-44.489h44.48V201.461z M293.848,154.973
h-44.48v-44.5h44.48V154.973z M293.848,108.473h-44.48v-44.5h44.48V108.473z M293.848,61.973h-44.48v-44.5h44.48V61.973z
M340.358,433.973h-44.49v-44.489h44.49V433.973z M340.358,387.461h-44.49v-44.477h44.49V387.461z M340.358,340.961h-44.49v-44.477
h44.49V340.961z M340.358,294.461h-44.49v-44.477h44.49V294.461z M340.358,247.961h-44.49v-44.477h44.49V247.961z M340.358,201.461
h-44.49v-44.489h44.49V201.461z M340.358,154.973h-44.49v-44.5h44.49V154.973z M340.358,108.473h-44.49v-44.5h44.49V108.473z
M386.858,433.973h-44.5v-44.489h44.5V433.973z M386.858,387.461h-44.5v-44.477h44.5V387.461z M386.858,340.961h-44.5v-44.477h44.5
V340.961z M386.858,294.461h-44.5v-44.477h44.5V294.461z M386.858,247.961h-44.5v-44.477h44.5V247.961z M386.858,201.461h-44.5
v-44.489h44.5V201.461z M386.858,154.973h-44.5v-44.5h44.5V154.973z M386.858,108.473h-44.5v-44.5h44.5V108.473z M433.358,387.461
h-44.5v-44.477h44.5V387.461z M433.358,340.961h-44.5v-44.477h44.5V340.961z M433.358,294.461h-44.5v-44.477h44.5V294.461z
M433.358,247.961h-44.5v-44.477h44.5V247.961z M433.358,201.461h-44.5v-44.489h44.5V201.461z M433.358,154.973h-44.5v-44.5h44.5
V154.973z M479.858,294.461h-44.5v-44.477h44.5V294.461z M479.858,247.961h-44.5v-44.477h44.5V247.961z"
    />
    <g>
      <path
        style={{ fill: "#294C22" }}
        d="M227.891,250.224c0.737,10.153,8.855,18.272,19.01,19.009v-19.009H227.891z"
      />
      <path
        style={{ fill: "#294C22" }}
        d="M227.891,247.224h19.01v-19.009C236.747,228.952,228.628,237.071,227.891,247.224z"
      />
      <path
        style={{ fill: "#294C22" }}
        d="M249.9,250.224v19.009c10.154-0.737,18.272-8.856,19.01-19.009H249.9z"
      />
      <path
        style={{ fill: "#294C22" }}
        d="M249.9,228.215v19.009h19.01C268.173,237.071,260.054,228.952,249.9,228.215z"
      />
    </g>
    <path
      style={{ fill: "#54C638" }}
      d="M496.461,247.224h-42.5c-0.81-112.167-91.895-203.252-204.06-204.058v-42.5
c-0.5-0.003-0.997-0.019-1.497-0.019c-0.502,0-1.001,0.016-1.503,0.019v42.5c-112.166,0.809-203.25,91.893-204.06,204.058h-42.5
c-0.004,0.503-0.02,1.002-0.02,1.506c0,0.5,0.016,0.995,0.02,1.494h42.5c0.805,112.164,91.891,203.249,204.06,204.058v42.5
c0.502,0.003,1.001,0.019,1.503,0.019c0.5,0,0.997-0.016,1.497-0.019v-42.5c112.169-0.806,203.255-91.892,204.06-204.058h42.5
c0.004-0.499,0.02-0.995,0.02-1.494C496.48,248.226,496.464,247.727,496.461,247.224z M246.9,451.282
c-110.515-0.809-200.255-90.548-201.06-201.058h47c0.802,84.595,69.461,153.252,154.06,154.058V451.282z M246.9,401.282
c-82.944-0.805-150.258-68.117-151.06-151.058h44.998c0.798,58.129,47.93,105.261,106.062,106.061V401.282z M246.9,353.285
c-56.478-0.8-102.265-46.585-103.062-103.061h40.516c0.79,34.143,28.401,61.754,62.546,62.545L246.9,353.285L246.9,353.285z
M246.9,309.769c-32.49-0.79-58.757-27.057-59.546-59.545h37.513c0.745,11.812,10.222,21.287,22.033,22.033V309.769z M246.9,269.233
c-10.154-0.737-18.272-8.856-19.01-19.009h19.01V269.233z M246.9,247.224h-19.01c0.737-10.153,8.856-18.272,19.01-19.009V247.224z
M246.9,225.191c-11.812,0.746-21.287,10.221-22.033,22.033h-37.513c0.791-32.488,27.057-58.755,59.546-59.545V225.191z
M246.9,184.679c-34.144,0.791-61.754,28.402-62.546,62.545h-40.516c0.801-56.476,46.586-102.261,103.062-103.061L246.9,184.679
L246.9,184.679z M246.9,141.163c-58.13,0.8-105.261,47.93-106.062,106.061H95.841c0.807-82.941,68.117-150.253,151.06-151.058
V141.163z M246.9,93.166c-84.597,0.806-153.253,69.462-154.06,154.058h-47c0.81-110.511,90.548-200.249,201.06-201.058V93.166z
M249.9,96.166c82.94,0.803,150.253,68.116,151.06,151.058h-44.998c-0.801-58.131-47.932-105.262-106.062-106.061V96.166z
M249.9,144.163c56.476,0.799,102.261,46.584,103.062,103.061h-40.516c-0.792-34.143-28.402-61.755-62.546-62.545L249.9,144.163
L249.9,144.163z M249.9,187.679c32.489,0.789,58.755,27.056,59.546,59.545h-37.513c-0.746-11.812-10.222-21.287-22.033-22.033
V187.679z M249.9,228.215c10.153,0.737,18.272,8.856,19.01,19.009H249.9V228.215z M249.9,250.224h19.01
c-0.737,10.153-8.855,18.272-19.01,19.009V250.224z M249.9,272.257c11.812-0.746,21.288-10.221,22.033-22.033h37.513
c-0.788,32.489-27.056,58.756-59.546,59.545V272.257z M249.9,312.769c34.145-0.79,61.756-28.402,62.546-62.545h40.516
C352.165,306.7,306.378,352.486,249.9,353.285V312.769z M249.9,356.285c58.132-0.799,105.264-47.93,106.062-106.061h44.998
c-0.802,82.942-68.116,150.255-151.06,151.058V356.285z M249.9,451.282v-47c84.598-0.804,153.258-69.462,154.06-154.058h47
C450.156,360.736,360.416,450.476,249.9,451.282z M403.961,247.224C403.154,162.627,334.496,93.97,249.9,93.166v-47
c110.511,0.806,200.25,90.545,201.06,201.058H403.961z"
    />
    <path
      style={{ fill: "#6EED4A" }}
      d="M327.773,13.651l-79.916,236.073l91.902-231.558C335.813,16.561,331.818,15.055,327.773,13.651z"
    />
    <g style={{ opacity: "0.6" }}>
      <path
        style={{ fill: "#6EED4A" }}
        d="M247.856,0v249.724l79.916-236.073C302.715,4.954,275.837,0.161,247.856,0z"
      />
    </g>
    <g>
      <circle style={{ fill: "#6EED4A" }} cx="103.361" cy="298.224" r={13} />
      <circle style={{ fill: "#6EED4A" }} cx="374.361" cy="338.224" r={13} />
    </g>
  </svg>


/* Four solid panels stepping down in opacity, the same device the dashboard
   charts use for rank. Drawn as fills rather than frames so the gaps hold at
   the 20px the dashboard hero runs it at. */
export const APPF_dashboardIcon =
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3.6" y="3.6" width="7.8" height="9.8" rx="1.8" fill="currentColor" />
    <rect x="12.6" y="3.6" width="7.8" height="5.8" rx="1.8" fill="currentColor" opacity="0.55" />
    <rect x="12.6" y="11.6" width="7.8" height="9.8" rx="1.8" fill="currentColor" opacity="0.8" />
    <rect x="3.6" y="15.6" width="7.8" height="5.8" rx="1.8" fill="currentColor" opacity="0.4" />
  </svg>


export const APPF_waveIcon = <svg
width={24}
height={22}
viewBox="0 0 15 12"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<path
  d="M11.25 6.5C12.14 6.5 12.69 6.76909 13.2363 7.0459V7.04492C13.6249 7.25399 13.9891 7.4392 14.5 7.51367V7.97852C13.8823 7.901 13.4519 7.68883 13.0137 7.4668H13.0127C12.5087 7.19567 12.0455 6.96289 11.25 6.96289C10.4704 6.96289 9.98039 7.2155 9.48926 7.46484L9.48633 7.4668L9.47559 7.47168C8.93169 7.74727 8.40578 8.0127 7.5 8.0127C6.59422 8.0127 6.06831 7.74727 5.52441 7.47168L5.51367 7.4668H5.5127C5.00673 7.19471 4.52946 6.96289 3.75 6.96289C3.1583 6.96289 2.73839 7.10549 2.3584 7.28223L1.98633 7.4668C1.55035 7.68769 1.11157 7.90028 0.5 7.97852V7.51074C0.845607 7.45694 1.12821 7.35201 1.3916 7.22949L1.76367 7.0459L1.77441 7.04102C2.31831 6.76542 2.84422 6.5 3.75 6.5C4.65578 6.5 5.18169 6.76542 5.72559 7.04102L5.73633 7.0459V7.04492C6.24071 7.3163 6.70397 7.5498 7.5 7.5498C8.27959 7.5498 8.76964 7.29718 9.26074 7.04785L9.26367 7.0459C9.81002 6.76909 10.36 6.5 11.25 6.5Z"
  fill="white"
  stroke="white"
/>
<path
  d="M11.25 9.5C12.14 9.5 12.69 9.76909 13.2363 10.0459V10.0449C13.6249 10.254 13.9891 10.4392 14.5 10.5137V10.9785C13.8823 10.901 13.4519 10.6888 13.0137 10.4668H13.0127C12.5087 10.1957 12.0455 9.96289 11.25 9.96289C10.4704 9.96289 9.98039 10.2155 9.48926 10.4648L9.48633 10.4668L9.47559 10.4717C8.93169 10.7473 8.40578 11.0127 7.5 11.0127C6.59422 11.0127 6.06831 10.7473 5.52441 10.4717L5.51367 10.4668H5.5127C5.00673 10.1947 4.52946 9.96289 3.75 9.96289C3.1583 9.96289 2.73839 10.1055 2.3584 10.2822L1.98633 10.4668C1.55035 10.6877 1.11157 10.9003 0.5 10.9785V10.5107C0.845607 10.4569 1.12821 10.352 1.3916 10.2295L1.76367 10.0459L1.77441 10.041C2.31831 9.76542 2.84422 9.5 3.75 9.5C4.65578 9.5 5.18169 9.76542 5.72559 10.041L5.73633 10.0459V10.0449C6.24071 10.3163 6.70397 10.5498 7.5 10.5498C8.27959 10.5498 8.76964 10.2972 9.26074 10.0479L9.26367 10.0459C9.81002 9.76909 10.36 9.5 11.25 9.5Z"
  fill="white"
  stroke="white"
/>
<path
  d="M11.25 0.5C12.14 0.5 12.69 0.769087 13.2363 1.0459V1.04492C13.6249 1.25399 13.9891 1.4392 14.5 1.51367V1.97852C13.8823 1.901 13.4519 1.68883 13.0137 1.4668H13.0127C12.5087 1.19567 12.0455 0.962891 11.25 0.962891C10.4704 0.962891 9.98039 1.2155 9.48926 1.46484L9.48633 1.4668L9.47559 1.47168C8.93169 1.74727 8.40578 2.0127 7.5 2.0127C6.59422 2.0127 6.06831 1.74727 5.52441 1.47168L5.51367 1.4668H5.5127C5.00673 1.19471 4.52946 0.962891 3.75 0.962891C3.1583 0.962891 2.73839 1.10549 2.3584 1.28223L1.98633 1.4668C1.55035 1.68769 1.11157 1.90028 0.5 1.97852V1.51074C0.845607 1.45694 1.12821 1.35201 1.3916 1.22949L1.76367 1.0459L1.77441 1.04102C2.31831 0.765423 2.84422 0.5 3.75 0.5C4.65578 0.5 5.18169 0.765423 5.72559 1.04102L5.73633 1.0459V1.04492C6.24071 1.3163 6.70397 1.5498 7.5 1.5498C8.27959 1.5498 8.76964 1.29718 9.26074 1.04785L9.26367 1.0459C9.81002 0.769087 10.36 0.5 11.25 0.5Z"
  fill="white"
  stroke="white"
/>
<path
  d="M11.25 3.5C12.14 3.5 12.69 3.76909 13.2363 4.0459V4.04492C13.6249 4.25399 13.9891 4.4392 14.5 4.51367V4.97852C13.8823 4.901 13.4519 4.68883 13.0137 4.4668H13.0127C12.5087 4.19567 12.0455 3.96289 11.25 3.96289C10.4704 3.96289 9.98039 4.2155 9.48926 4.46484L9.48633 4.4668L9.47559 4.47168C8.93169 4.74727 8.40578 5.0127 7.5 5.0127C6.59422 5.0127 6.06831 4.74727 5.52441 4.47168L5.51367 4.4668H5.5127C5.00673 4.19471 4.52946 3.96289 3.75 3.96289C3.1583 3.96289 2.73839 4.10549 2.3584 4.28223L1.98633 4.4668C1.55035 4.68769 1.11157 4.90028 0.5 4.97852V4.51074C0.845607 4.45694 1.12821 4.35201 1.3916 4.22949L1.76367 4.0459L1.77441 4.04102C2.31831 3.76542 2.84422 3.5 3.75 3.5C4.65578 3.5 5.18169 3.76542 5.72559 4.04102L5.73633 4.0459V4.04492C6.24071 4.3163 6.70397 4.5498 7.5 4.5498C8.27959 4.5498 8.76964 4.29718 9.26074 4.04785L9.26367 4.0459C9.81002 3.76909 10.36 3.5 11.25 3.5Z"
  fill="#C12A0C"
/>
<path
  d="M11.25 3.5C12.14 3.5 12.69 3.76909 13.2363 4.0459V4.04492C13.6249 4.25399 13.9891 4.4392 14.5 4.51367V4.97852C13.8823 4.901 13.4519 4.68883 13.0137 4.4668H13.0127C12.5087 4.19567 12.0455 3.96289 11.25 3.96289C10.4704 3.96289 9.98039 4.2155 9.48926 4.46484L9.48633 4.4668L9.47559 4.47168C8.93169 4.74727 8.40578 5.0127 7.5 5.0127C6.59422 5.0127 6.06831 4.74727 5.52441 4.47168L5.51367 4.4668H5.5127C5.00673 4.19471 4.52946 3.96289 3.75 3.96289C3.1583 3.96289 2.73839 4.10549 2.3584 4.28223L1.98633 4.4668C1.55035 4.68769 1.11157 4.90028 0.5 4.97852V4.51074C0.845607 4.45694 1.12821 4.35201 1.3916 4.22949L1.76367 4.0459L1.77441 4.04102C2.31831 3.76542 2.84422 3.5 3.75 3.5C4.65578 3.5 5.18169 3.76542 5.72559 4.04102L5.73633 4.0459V4.04492C6.24071 4.3163 6.70397 4.5498 7.5 4.5498C8.27959 4.5498 8.76964 4.29718 9.26074 4.04785L9.26367 4.0459C9.81002 3.76909 10.36 3.5 11.25 3.5Z"
  fill="white"
/>
<path
  d="M11.25 3.5C12.14 3.5 12.69 3.76909 13.2363 4.0459V4.04492C13.6249 4.25399 13.9891 4.4392 14.5 4.51367V4.97852C13.8823 4.901 13.4519 4.68883 13.0137 4.4668H13.0127C12.5087 4.19567 12.0455 3.96289 11.25 3.96289C10.4704 3.96289 9.98039 4.2155 9.48926 4.46484L9.48633 4.4668L9.47559 4.47168C8.93169 4.74727 8.40578 5.0127 7.5 5.0127C6.59422 5.0127 6.06831 4.74727 5.52441 4.47168L5.51367 4.4668H5.5127C5.00673 4.19471 4.52946 3.96289 3.75 3.96289C3.1583 3.96289 2.73839 4.10549 2.3584 4.28223L1.98633 4.4668C1.55035 4.68769 1.11157 4.90028 0.5 4.97852V4.51074C0.845607 4.45694 1.12821 4.35201 1.3916 4.22949L1.76367 4.0459L1.77441 4.04102C2.31831 3.76542 2.84422 3.5 3.75 3.5C4.65578 3.5 5.18169 3.76542 5.72559 4.04102L5.73633 4.0459V4.04492C6.24071 4.3163 6.70397 4.5498 7.5 4.5498C8.27959 4.5498 8.76964 4.29718 9.26074 4.04785L9.26367 4.0459C9.81002 3.76909 10.36 3.5 11.25 3.5Z"
  stroke="#C12A0C"
/>
</svg>


// <svg
//   width={38}
//   height={36}
//   viewBox="0 0 49 47"
//   fill="none"
//   xmlns="http://www.w3.org/2000/svg"
// >
//   <path
//     d="M5.41319 39.5886L0.629395 36.707L0.537717 43.0814L5.32421 45.7755L9.43592 43.7719L13.4883 45.8929L18.5359 43.3402L18.6275 36.9659L13.5773 39.706L9.5276 37.3976L5.41319 39.5886Z"
//     stroke="white"
//   />
//   <path
//     d="M12.8299 5.08203L0.5 0.707031V10.6237L12.8299 14.707L23.2629 11.4987L33.6959 14.707L46.5 10.6237V0.707031L33.6959 5.08203L23.2629 1.58203L12.8299 5.08203Z"
//     stroke="white"
//   />
//   <path
//     d="M48.5 12.707L35.3378 20.1402L24.5012 14.1585L13.6646 20.1403L7.5 16.707L2.38842 13.9141L0.5 12.707V14.9581V29.6525L13.6646 36.9203L24.4988 30.9386L35.333 36.9227L48.5 29.6525V12.707ZM35.3354 32.59L24.5012 26.6059L13.667 32.59L4.28394 27.4079V19.2907L13.667 24.4704L24.5035 18.4887L35.3401 24.4704L44.7232 19.2884V27.4055L35.3401 32.5876L35.3354 32.59Z"
//     fill="url(#paint0_linear_0_1)"
//   />
//   <defs>
//     <linearGradient
//       id="paint0_linear_0_1"
//       x1="0.5"
//       y1="20.0117"
//       x2="25.0358"
//       y2="72.7156"
//       gradientUnits="userSpaceOnUse"
//     >
//       <stop offset="0.122862" stopColor="#FF3710" />
//       <stop offset={1} />
//     </linearGradient>
//   </defs>
// </svg>




export const APPF_discoveryIcon =
  <svg width="28" height="24" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.8965 7.98278C14.6105 7.98278 16 6.59331 16 4.87933C16 3.16534 14.6105 1.77588 12.8965 1.77588C11.1826 1.77588 9.79309 3.16534 9.79309 4.87933C9.79309 6.59331 11.1826 7.98278 12.8965 7.98278Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M9.5345 9.01721H3.84485V14.7069H9.5345V9.01721Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
    <path d="M1 6.43103L4.36207 1L7.72414 6.43103H1Z" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="square" />
  </svg>

export const APPF_factorIcon =
  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="server" className="svg-inline--fa fa-server fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path fill="currentColor" d="M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"></path>
  </svg>


export const APPF_multiverseIcon =
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11ZM6 3C7.65 3 9 4.35 9 6C9 7.65 7.65 9 6 9C4.35 9 3 7.65 3 6C3 4.35 4.35 3 6 3Z" fill="currentColor" />
      <path d="M21 14H16C14.9 14 14 14.9 14 16V21C14 22.1 14.9 23 16 23H21C22.1 23 23 22.1 23 21V16C23 14.9 22.1 14 21 14ZM21 21H16V16H21V21Z" fill="currentColor" />
      <path d="M17.71 7.7C18.11 7.89 18.54 8 19 8C20.65 8 22 6.65 22 5C22 3.35 20.65 2 19 2C17.35 2 16 3.35 16 5C16 5.46 16.11 5.89 16.3 6.29L6.29 16.3C5.89 16.11 5.46 16 5 16C3.35 16 2 17.35 2 19C2 20.65 3.35 22 5 22C6.65 22 8 20.65 8 19C8 18.54 7.89 18.11 7.7 17.71L17.71 7.7Z" fill="currentColor" />
    </g>
  </svg>

export const APPF_aiIcon =
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M12 2C7.58 2 4 5.58 4 10C4 13.54 6.36 16.54 9.6 17.6V20C9.6 20.55 10.05 21 10.6 21H13.4C13.95 21 14.4 20.55 14.4 20V17.6C17.64 16.54 20 13.54 20 10C20 5.58 16.42 2 12 2ZM12 4C15.31 4 18 6.69 18 10C18 12.61 16.33 14.81 14 15.62V16H10V15.62C7.67 14.81 6 12.61 6 10C6 6.69 8.69 4 12 4Z" fill="white" />
      <circle cx="9.5" cy="9.5" r="1.5" fill="white" />
      <circle cx="14.5" cy="9.5" r="1.5" fill="white" />
      <path d="M9.5 9.5L12 12L14.5 9.5" stroke="white" strokeWidth="1" fill="none" />
      <rect x="10" y="21.5" width="4" height="1" rx="0.5" fill="white" />
    </g>
  </svg>


const APPF_refreshIcon = <svg
  fill="currentColor"
  width="44px"

  height="44px"
  viewBox="0 0 64 64"
  enableBackground="new 0 0 64 64"
  xmlns="http://www.w3.org/2000/svg"
  style={{
    transformOrigin: "50%",
    border: "0px solid transparent",
    backgroundColor: "transparent",
    borderRadius: 4,
    marginTop: -12, marginLeft: -5,
  }}
>
  <g >
    <path
      d="M23.022,48.047c-3.63,0.001-7.495-2.154-7.507-6.147c-0.012-4.06-0.101-7.425-0.194-10.987   c-0.041-1.57-0.084-3.196-0.123-4.963c-0.136-6.182,2.163-9.457,6.835-9.734c2.682-0.159,7.159-0.262,11.408-0.262   c3.565,0,9.776,0.071,11.313,0.554c2.228,0.7,3.53,2.496,3.873,5.34c0.314,2.612,0.139,11.938,0.045,16.947   c-0.026,1.394-0.046,2.433-0.046,2.863c0.001,1.831-0.763,3.472-2.148,4.619c-1.399,1.158-3.358,1.771-5.664,1.771l-2.738-0.006   c-4.22-0.011-11.683-0.031-14.961,0.006C23.112,48.047,23.026,48.047,23.022,48.047z M33.441,17.953   c-4.213,0-8.645,0.101-11.289,0.258c-3.539,0.21-5.067,2.583-4.954,7.694c0.038,1.764,0.081,3.387,0.122,4.954   c0.095,3.574,0.184,6.951,0.195,11.034c0.009,3.048,3.298,4.154,5.507,4.153h0.071c3.285-0.036,10.761-0.016,14.987-0.006   l2.733,0.006c1.835,0,3.353-0.453,4.389-1.312c0.932-0.771,1.424-1.836,1.424-3.078c0-0.437,0.02-1.489,0.046-2.901   c0.087-4.607,0.268-14.195-0.031-16.671c-0.324-2.691-1.574-3.384-2.486-3.67C43.476,18.202,40.262,17.953,33.441,17.953z" />
  </g>
  <g

    style={{ transformOrigin: "50%" }}>
    <animateTransform
      attributeName="transform"
      type="rotate"
      from="120 262.5 125"
      to="0 262.5 125"
      begin={0}
      dur="0.42s"
      repeatCount="indefinite"
      keyTimes="0;0.5;1"
      values="0 0 0; 180 0 0; 360 0 0"
    />
    <g>
      <path d="M34.606,41.895c-0.513,0-1.032-0.003-1.576-0.011c-2.62-0.037-5.881-0.084-7.229-3.524   c-0.815-2.081-0.641-4.854-0.513-6.881l0.047-0.792c0.029-0.552,0.502-0.983,1.051-0.947c0.552,0.029,0.976,0.499,0.947,1.051   l-0.049,0.814c-0.116,1.839-0.275,4.357,0.378,6.024c0.802,2.043,2.573,2.215,5.397,2.255c0.938,0.014,1.805,0.011,2.681,0.008   c0.681-0.003,1.37-0.004,2.104,0c0.553,0.004,0.997,0.455,0.993,1.007c-0.004,0.55-0.451,0.993-1,0.993c-0.002,0-0.005,0-0.007,0   c-0.729-0.004-1.41-0.004-2.084,0C35.366,41.893,34.988,41.895,34.606,41.895z" />
    </g>
    <g>
      <path d="M29.796,34.047c-0.183,0-0.368-0.05-0.534-0.155c-1.047-0.662-2.657-1.685-3.481-2.225   c-0.462-0.303-0.59-0.923-0.287-1.385c0.303-0.46,0.921-0.591,1.385-0.287c0.816,0.536,2.415,1.549,3.454,2.207   c0.467,0.295,0.605,0.913,0.31,1.38C30.451,33.883,30.127,34.047,29.796,34.047z" />
    </g>
    <g>
      <path d="M22.862,33.955c-0.331,0-0.655-0.164-0.846-0.465c-0.296-0.467-0.157-1.084,0.31-1.38c1.038-0.657,2.636-1.671,3.454-2.208   c0.462-0.304,1.081-0.173,1.385,0.287c0.303,0.462,0.175,1.082-0.287,1.385c-0.824,0.541-2.436,1.563-3.481,2.226   C23.23,33.905,23.045,33.955,22.862,33.955z" />
    </g>
    <g>
      <path d="M37.685,34.209c-0.018,0-0.035,0-0.052-0.001c-0.552-0.028-0.977-0.499-0.948-1.05l0.049-0.823   c0.115-1.836,0.273-4.352-0.379-6.016c-0.8-2.042-2.572-2.215-5.396-2.256c-0.941-0.015-1.813-0.012-2.694-0.007   c-0.677,0.002-1.362,0.004-2.091,0c-0.552-0.004-0.997-0.454-0.993-1.007c0.004-0.55,0.45-0.993,1-0.993c0.002,0,0.004,0,0.007,0   c0.722,0.005,1.4,0.002,2.069,0c0.895-0.005,1.775-0.007,2.73,0.007c2.621,0.038,5.883,0.086,7.229,3.526   c0.815,2.076,0.641,4.848,0.514,6.87l-0.047,0.8C38.655,33.794,38.213,34.209,37.685,34.209z" />
    </g>
    <g>
      <path d="M37.687,34.117c-0.188,0-0.379-0.053-0.548-0.164c-0.817-0.537-2.416-1.55-3.453-2.207   c-0.467-0.295-0.606-0.913-0.311-1.379c0.294-0.467,0.914-0.607,1.379-0.311c1.047,0.661,2.657,1.684,3.482,2.225   c0.462,0.303,0.59,0.923,0.287,1.385C38.332,33.958,38.013,34.117,37.687,34.117z" />
    </g>
    <g>
      <path d="M37.689,34.209c-0.326,0-0.646-0.159-0.837-0.451c-0.303-0.462-0.175-1.082,0.287-1.385c0.824-0.54,2.435-1.562,3.48-2.225   c0.468-0.297,1.085-0.156,1.38,0.31c0.296,0.467,0.157,1.084-0.31,1.38c-1.038,0.657-2.637,1.671-3.453,2.207   C38.067,34.156,37.878,34.209,37.689,34.209z" />
    </g>
    <g></g>
  </g>
</svg>


export const menuTogleIcon =
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ position: 'absolute', right: 58 }}>
    <g opacity="0.5" clipPath="url(#clip0_1818_57)">
      <path d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_1818_57">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>

export const APPF_bitBucket = <svg

  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 92 92"
  width={28}
  height={28}
>
  <defs>
    <style
      dangerouslySetInnerHTML={{
        __html:
          "\n    .header__svg-logo__icon--path--3{fill:#2684ff;}\n    .header__svg-logo__icon--path--4{fill:url(#logo-gradient);}\n    "
      }}
    />
    <linearGradient
      id="logo-gradient"
      x1="64.01"
      y1="65.26"
      x2="32.99"
      y2="89.48"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.18" stopColor="#0052cc" />
      <stop offset={1} stopColor="#2684ff" />
    </linearGradient>
  </defs>
  <g transform={"translate(14,-20) "}>
    <path

      className="header__svg-logo__icon--path--3"
      d="M2,41.25a2,2,0,0,0-2,2.32L8.49,95.11a2.72,2.72,0,0,0,2.66,2.27H51.88a2,2,0,0,0,2-1.68l8.51-52.11a2,2,0,0,0-2-2.32ZM37.75,78.5h-13L21.23,60.12H40.9Z"
    />
    <path
      className="header__svg-logo__icon--path--4"
      d="M59.67,60.12H40.9L37.75,78.5h-13L9.4,96.73a2.71,2.71,0,0,0,1.75.66H51.89a2,2,0,0,0,2-1.68Z"
    />
  </g>
</svg>


export const APPF_gitLab =
  <svg width="22" height="22" viewBox="0 0 32 32" fill="none"  role="img" aria-labelledby="tanukiHomeDesktop" data-v-52cd803a=""><path d="M31.4618 12.7787L31.417 12.6641L27.0667 1.31308C26.9783 1.09046 26.8218 0.90145 26.6197 0.773028C26.416 0.644476 26.1775 0.582308 25.937 0.595107C25.6965 0.607906 25.4659 0.695039 25.277 0.844481C25.0899 0.994513 24.955 1.1998 24.8915 1.43106L21.9503 10.4324H10.0509L7.10976 1.43106C7.04625 1.1998 6.91133 0.994513 6.72425 0.844481C6.53618 0.694035 6.30572 0.606246 6.06523 0.593431C5.82473 0.580616 5.58625 0.64342 5.38326 0.773028C5.18023 0.900924 5.02312 1.09005 4.9346 1.31308L0.579314 12.679L0.534448 12.792C-0.0907536 14.429 -0.167604 16.2247 0.315452 17.9091C0.798508 19.5935 1.81536 21.0756 3.21309 22.1324L3.22971 22.144L3.26793 22.1739L9.90306 27.1407L13.1832 29.625L15.1773 31.1354C15.4115 31.3124 15.6971 31.4082 15.9907 31.4082C16.2842 31.4082 16.5698 31.3124 16.8041 31.1354L18.7981 29.625L22.0799 27.1407L28.7533 22.144L28.7715 22.1307C30.174 21.0749 31.1949 19.5916 31.6802 17.9045C32.1656 16.2175 32.0889 14.4184 31.4618 12.7787Z" fill="#E24329"></path><path d="M31.462 12.7787L31.4172 12.6641C29.2955 13.1013 27.2962 14.0005 25.5614 15.2978L16.0083 22.5378C19.2652 25.0005 22.1001 27.1407 22.1001 27.1407L28.7734 22.144L28.7917 22.1307C30.1907 21.0723 31.2076 19.5877 31.6893 17.9009C32.171 16.214 32.0912 14.4163 31.462 12.7787Z" fill="#FC6D26"></path><path d="M9.9082 27.1407L13.1834 29.625L15.1774 31.1354C15.4117 31.3124 15.6972 31.4082 15.9908 31.4082C16.2844 31.4082 16.57 31.3124 16.8042 31.1354L18.7982 29.625L22.0801 27.1407C22.0801 27.1407 19.2452 25.0005 15.9883 22.5378L9.9082 27.1407Z" fill="#FCA326"></path><path d="M6.43513 15.3045C4.70076 14.0067 2.70123 13.108 0.579333 12.6724L0.534467 12.7854C-0.0923403 14.4232 -0.170036 16.2203 0.313079 17.9061C0.796194 19.5919 1.81396 21.0751 3.21311 22.1324L3.22973 22.144L3.26795 22.1739L9.90307 27.1407L16.0081 22.5378L6.43513 15.3045Z" fill="#FC6D26"></path></svg>

export const APPF_gitHub = <svg
  height={32}
  aria-hidden="true"
  viewBox="0 0 16 16"
  version="1.1"
  width={22}
  style={{
    marginTop: -4
  }}
  data-view-component="true"
  className="octicon octicon-mark-github v-align-middle color-fg-default"
>
  <path fill="white" d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z" />
</svg>


export const loadingIcon =
  <svg
    version="1.1"
    id="L1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width={24}
    height={24}
    viewBox="0 0 100 100"
    enableBackground="new 0 0 100 100"
    xmlSpace="preserve"
  >
    <circle
      fill="none"
      stroke="#ffffff99"
      strokeWidth={6}
      strokeMiterlimit={15}
      strokeDasharray="14.2472,14.2472"
      cx={50}
      cy={50}
      r={47}
    >
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur="5s"
        from="0 50 50"
        to="360 50 50"
        repeatCount="indefinite"
      />
    </circle>
    <circle
      fill="none"
      stroke="#fff"
      strokeWidth={1}
      strokeMiterlimit={10}
      strokeDasharray="10,10"
      cx={50}
      cy={50}
      r={39}
    >
      <animateTransform
        attributeName="transform"
        attributeType="XML"
        type="rotate"
        dur="5s"
        from="0 50 50"
        to="-360 50 50"
        repeatCount="indefinite"
      />
    </circle>
    <g fill="#fff">
      <rect x={30} y={35} width={5} height={30}>
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.1"
        />
      </rect>
      <rect x={40} y={35} width={5} height={30}>
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.2"
        />
      </rect>
      <rect x={50} y={35} width={5} height={30}>
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.3"
        />
      </rect>
      <rect x={60} y={35} width={5} height={30}>
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.4"
        />
      </rect>
      <rect x={70} y={35} width={5} height={30}>
        <animateTransform
          attributeName="transform"
          dur="1s"
          type="translate"
          values="0 5 ; 0 -5; 0 5"
          repeatCount="indefinite"
          begin="0.5"
        />
      </rect>
    </g>
  </svg>

export const loadingMultiverse =
  <svg
    width={"100%"}
    height={"100%"}
    viewBox="0 0 1956 1188"
  >
    <defs>
      <linearGradient id="c1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="currentColor" opacity={1} />
        <stop offset="100%" stopColor="currentColor" opacity={1} />
      </linearGradient>
    </defs>
    <rect width={1956} height={1188} x={0} y={0} fill="none" />
    <path
      d="M1442.3834 616.3215Q994.6725 647.9202 653.6507 941.2933"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(0.07,0.998,-0.998,0.07,1405.2327,614.5358)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1442.58 613.5046Q1040.6324 526.7657 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.211,0.977,-0.977,-0.211,1405.4136,611.9443)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1438.6802 656.426Q1109.1508 580.4232 1429.2688 445.0989"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.225,0.974,-0.974,-0.225,1401.8257,651.4319)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1438.4826 657.6252Q972.4983 609.0953 504.7688 637.2122"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.104,0.995,-0.995,-0.104,1401.644,652.5352)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1438.8699 655.7101Q1040.1129 532.6669 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.295,0.956,-0.956,-0.295,1402.0003,650.7732)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1438.4273 658.556Q994.1017 653.7869 653.6507 941.2933"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.011,1,-1,-0.011,1401.5931,653.3915)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1430.9722 698.4669Q981.2645 572.3716 571.9799 347.0937"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.27,0.963,-0.963,-0.27,1394.7344,690.1095)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1431.3286 697.4124Q1039.0645 538.493 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.375,0.927,-0.927,-0.375,1395.0623,689.1394)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1420.018 738.2642Q1037.4958 544.1967 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.452,0.892,-0.892,-0.452,1384.6566,726.7231)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1419.8248 738.671Q1007.0457 552.2568 759.3771 172.0769"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.412,0.911,-0.911,-0.412,1384.4788,727.0974)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1419.5504 739.3466Q979.6967 578.0232 571.9799 347.0937"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.344,0.939,-0.939,-0.344,1384.2264,727.7189)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1405.0294 777.9239Q1035.4196 549.7305 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.525,0.851,-0.851,-0.525,1370.8671,763.21)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1404.7845 778.3458Q1004.9802 557.766 759.3771 172.0769"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.483,0.876,-0.876,-0.483,1370.6418,763.5981)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1404.8911 778.1579Q1016.6846 552.9042 839.4098 139.4587"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.502,0.865,-0.865,-0.502,1370.7398,763.4253)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1386.486 816.0602Q1032.853 555.0487 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.594,0.805,-0.805,-0.594,1353.8071,798.2954)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1386.3761 816.2142Q1020.2614 556.5923 881.3177 128.7392"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.578,0.816,-0.816,-0.578,1353.706,798.4371)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1364.5408 852.3543Q1029.8173 560.1075 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.658,0.753,-0.753,-0.658,1333.6176,831.686)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1339.3756 886.5027Q1026.3376 564.8652 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.717,0.697,-0.697,-0.717,1310.4656,863.1025)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1309.4097 920.1419Q964.1501 675.3516 571.9799 840.9063"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.578,0.816,-0.816,-0.578,1282.8969,894.0505)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1311.1982 918.2188Q1022.4427 569.2817 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.77,0.638,-0.638,-0.77,1284.5424,892.2813)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1278.4209 948.8794Q954.3349 667.8924 533.976 763.2861"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.655,0.756,-0.756,-0.655,1254.3872,920.489)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1280.7653 946.8938Q1060.1071 585.734 1252.0385 205.7759"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.853,0.521,-0.521,-0.853,1256.5441,918.6623)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1280.5797 947.0114Q1043.1304 577.1451 1137.1348 146.2376"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.842,0.54,-0.54,-0.842,1256.3733,918.7705)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1279.4443 947.8629Q972.2805 592.1699 653.6507 246.7067"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.757,0.654,-0.654,-0.757,1255.3287,919.5538)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1280.335 947.1748Q1024.5063 573.4255 1010.4288 119.9078"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.825,0.565,-0.565,-0.825,1256.1482,918.9208)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1247.5314 972.9094Q1073.3739 607.3219 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.903,0.43,-0.43,-0.903,1225.9688,942.5967)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1247.3638 972.9924Q1055.452 589.3842 1252.0385 205.7759"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.894,0.447,-0.447,-0.894,1225.8147,942.673)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1246.0169 973.8085Q972.4706 591.6573 686.5756 218.651"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.813,0.582,-0.582,-0.813,1224.5755,943.4239)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1246.1254 973.732Q977.6443 588.0054 721.9154 193.7055"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.821,0.571,-0.571,-0.821,1224.6753,943.3534)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1211.9586 995.8493Q1071.7674 615.9396 1394.8372 365.8294"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.938,0.346,-0.346,-0.938,1193.2419,963.7014)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1211.8929 995.8747Q1064.5373 605.448 1346.618 294.107"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.936,0.353,-0.353,-0.936,1193.1815,963.7247)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1172.3291 1016.3029Q953.0453 606.1126 623.4135 277.6403"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.882,0.471,-0.471,-0.882,1156.7828,982.5187)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1171.4381 1016.8367Q937.4483 671.3002 520.4217 722.2074"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.828,0.561,-0.561,-0.828,1155.9631,983.0098)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1173.3953 1015.8107Q1003.4046 582.8619 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.931,0.365,-0.365,-0.931,1157.7636,982.0658)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1171.3795 1016.8757Q941.8502 683.2572 551.2097 802.9619"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.824,0.567,-0.567,-0.824,1155.9091,983.0457)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1132.427 1032.5474Q930.838 641.9771 510.659 507.9336"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.889,0.459,-0.459,-0.889,1120.0729,997.4636)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1134.1063 1031.8675Q997.9784 585.0944 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.957,0.291,-0.291,-0.957,1121.6178,996.8381)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1133.0075 1032.2734Q947.5997 608.3063 623.4135 277.6403"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.916,0.401,-0.401,-0.916,1120.6069,997.2115)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1092.8351 1044.4514Q998.7554 727.2719 1010.4288 1068.0922"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.959,0.284,-0.284,-0.959,1083.6483,1008.4153)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1092.4999 1044.557Q985.7984 726.9157 924.0267 1066.1249"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.948,0.318,-0.318,-0.948,1083.3399,1008.5125)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1091.908 1044.7732Q926.6706 637.4897 520.4217 465.7926"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.927,0.376,-0.376,-0.927,1082.7953,1008.7114)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1094.679 1044.0868Q1052.015 617.2786 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.995,0.099,-0.099,-0.995,1085.3447,1008.0798)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1093.767 1044.2239Q1005.0018 587.6473 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.982,0.191,-0.191,-0.982,1084.5056,1008.206)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1053.1935 1052.8334Q1046.2347 618.5118 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-1,0.016,-0.016,-1,1047.178,1016.1267)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1051.0655 1053.0994Q945.5113 602.5637 686.5756 218.651"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.974,0.228,-0.228,-0.974,1045.2203,1016.3715)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1052.2196 1052.8993Q999.261 588.8601 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.994,0.113,-0.113,-0.994,1046.2821,1016.1874)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1011.0755 1057.7645Q1040.3716 619.2158 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.998,-0.067,0.067,-0.998,1008.4295,1020.6634)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1010.0525 1057.751Q993.4356 589.5413 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.999,0.035,-0.035,-0.999,1007.4883,1020.6509)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1008.8953 1057.859Q939.6718 603.2039 686.5756 218.651"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.989,0.151,-0.151,-0.989,1006.4237,1020.7502)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M967.6172 1058.7382Q987.5742 589.6851 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.999,-0.043,0.043,-0.999,968.4478,1021.5591)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M968.6763 1058.8374Q1034.4743 619.3848 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="rgb(128,128,128)"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.989,-0.148,0.148,-0.989,969.4222,1021.6504)"
      fill="rgb(128,128,128)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M965.7551 1058.828Q906.6483 651.8982 504.7688 550.7878"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.99,0.144,-0.144,-0.99,966.7347,1021.6418)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M966.0168 1058.7953Q923.622 705.375 623.4135 910.3597"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.993,0.119,-0.119,-0.993,966.9754,1021.6117)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M926.3491 1056.0415Q1028.5914 619.0175 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="rgb(128,128,128)"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.974,-0.228,0.228,-0.974,930.4812,1019.0782)"
      fill="rgb(128,128,128)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M925.268 1055.8516Q981.7254 589.2901 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.993,-0.12,0.12,-0.993,929.4865,1018.9035)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M924.0399 1055.7775Q923.0677 606.954 653.6507 246.7067"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-1,0.002,-0.002,-1,928.3567,1018.8353)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M883.0987 1049.0672Q963.3153 587.481 967.1829 118.9231"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.985,-0.171,0.171,-0.985,890.6908,1012.6618)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M843.101 1038.8743Q1009.02 606.9078 1317.82 261.8293"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.934,-0.359,0.359,-0.934,853.8929,1003.2843)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M841.509 1038.4082Q932.9218 591.0351 798.6504 153.9446"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.98,-0.2,0.2,-0.98,852.4283,1002.8555)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M840.766 1038.2829Q888.7682 655.4534 502.8 594"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.992,-0.124,0.124,-0.992,851.7447,1002.7402)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M841.8612 1038.4882Q951.3153 586.4249 924.0267 121.8751"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.972,-0.235,0.235,-0.972,852.7523,1002.9292)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M841.2881 1038.3655Q902.1752 697.6618 596.1145 876.8047"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.984,-0.176,0.176,-0.984,852.2251,1002.8162)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M843.3214 1038.9608Q1017.064 616.6901 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="rgb(128,128,128)"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.925,-0.38,0.38,-0.925,854.0957,1003.3639)"
      fill="rgb(128,128,128)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M842.3642 1038.624Q976.4594 588.1958 1095.7583 133.6219"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.958,-0.285,0.285,-0.958,853.2151,1003.0541)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M841.1106 1038.3342Q911.5466 604.4885 653.6507 246.7067"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.987,-0.16,0.16,-0.987,852.0618,1002.7874)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M840.8001 1038.2873Q893.6735 630.5007 533.976 424.7139"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.992,-0.129,0.129,-0.992,851.7761,1002.7443)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M842.237 1038.5872Q970.2601 586.9024 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.962,-0.273,0.273,-0.962,853.098,1003.0203)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M803.3132 1024.818Q1011.514 614.7503 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.892,-0.453,0.453,-0.892,817.2881,990.3526)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M801.0592 1023.9917Q897.4377 611.8781 596.1145 311.1953"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.974,-0.228,0.228,-0.974,815.2144,989.5923)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M803.515 1024.9221Q1017.6637 625.8267 1413.8588 404.6798"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.881,-0.473,0.473,-0.881,817.4738,990.4484)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M801.0611 1023.9919Q884.1871 666.2713 510.659 680.0664"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.974,-0.226,0.226,-0.974,815.2163,989.5925)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M800.9673 1023.9703Q890.7037 622.6812 551.2097 385.0381"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.976,-0.218,0.218,-0.976,815.1299,989.5727)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M764.1967 1006.7659Q983.1589 590.9262 1215.6 182.4647"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.885,-0.466,0.466,-0.885,781.301,973.7447)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M726.4694 985.0028Q877.0193 673.3605 533.976 763.2861"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.9,-0.435,0.435,-0.9,746.5919,953.7226)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M726.8794 985.2152Q948.0563 578.7611 1010.4288 119.9078"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.878,-0.478,0.478,-0.878,746.969,953.918)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M727.2109 985.4041Q966.6011 582.6774 1137.1348 146.2376"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.86,-0.511,0.511,-0.86,747.274,954.0918)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M692.3447 960.7587Q949.5661 576.1013 1053.4059 124.8209"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.831,-0.556,0.556,-0.831,715.1972,931.418)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M693.2787 961.4655Q996.2681 606.03 1372.3615 328.8697"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.761,-0.649,0.649,-0.761,716.0564,932.0683)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M692.9741 961.2162Q983.6303 591.9114 1286.2062 232.304"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.786,-0.618,0.618,-0.786,715.7761,931.8389)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M692.6576 960.977Q967.6779 581.6877 1177.1927 162.5637"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.81,-0.587,0.587,-0.81,715.485,931.6188)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M1419.8154 738.6923Q1108.2169 598.0439 1440.9394 486.7519"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.411,0.911,-0.911,-0.411,1384.4701,727.117)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M765.2209 1007.3834Q1017.5586 641.6325 1448.774 529.2936"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.823,-0.568,0.568,-0.823,782.2433,974.3127)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M728.5115 986.3216Q1013.0632 645.0324 1452.7075 572.3715"
      transform="matrix(0.92,0,0,0.92,78.24,47.52)"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.0869565217391304"
      strokeOpacity="0.85"
      className="zr25-cls-0"
    />
    <path
      d="M0 0A0 0 0 1 1 0 0"
      transform="matrix(-0.768,-0.64,0.64,-0.768,748.4706,954.9359)"
      fill="url(#c1)"
      fillOpacity="0.85"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1414.7309,613.8983)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1411.112,653.5299)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1403.9043,692.6682)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1393.1673,730.989)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1378.9901,768.1746)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1361.4902,803.9169)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1340.8126,837.9198)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1317.1286,869.9016)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1290.6344,899.5971)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1261.5497,926.7603)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1230.1154,951.1662)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1196.592,972.6125)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1161.2573,990.9214)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1124.404,1005.9414)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1086.3376,1017.5479)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1047.3735,1025.6447)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,1007.8345,1030.1648)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,968.0483,1031.0707)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,928.3446,1028.3549)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,889.0523,1022.0399)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,850.4971,1012.178)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,812.9984,998.851)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,776.8669,982.1692)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,742.4021,962.271)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M-0.5 -1L0.5 -1A0.5 0.5 0 0 1 1 -0.5L1 0.5A0.5 0.5 0 0 1 0.5 1L-0.5 1A0.5 0.5 0 0 1 -1 0.5L-1 -0.5A0.5 0.5 0 0 1 -0.5 -1"
      transform="matrix(9.52,0,0,9.52,709.8896,939.3211)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,679.5987,913.5098)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,651.7804,885.0509)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,626.6653,854.1803)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,604.4615,821.1538)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,585.3529,786.245)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,569.498,749.7432)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,557.028,711.9508)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,548.0463,673.1811)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,542.6273,633.7553)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,540.816,594)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,542.6273,554.2447)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,548.0463,514.8189)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,557.028,476.0492)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,569.498,438.2568)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,585.3529,401.755)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,604.4615,366.8462)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,626.6653,333.8197)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,651.7804,302.9491)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,679.5987,274.4902)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,709.8896,248.6789)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,742.4021,225.729)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,776.8669,205.8308)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,812.9984,189.149)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,850.4971,175.822)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,889.0523,165.9601)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,928.3446,159.6451)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,968.0483,156.9293)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1007.8345,157.8352)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1047.3735,162.3553)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1086.3376,170.4521)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1124.404,182.0586)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1161.2573,197.0786)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1196.592,215.3875)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1230.1154,236.8338)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1261.5497,261.2397)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1290.6344,288.4029)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1317.1286,318.0984)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1340.8126,350.0802)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1361.4902,384.0831)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1378.9901,419.8254)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1393.1673,457.011)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1403.9043,495.3318)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1411.112,534.4701)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <path
      d="M1 0A1 1 0 1 1 1 -0.0001"
      transform="matrix(9.52,0,0,9.52,1414.7309,574.1017)"
      fill="url(#c1)"
      className="zr25-cls-1"
    />
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.999,0.046,-0.046,0.999,1429.2359,614.5591)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.991,0.136,-0.136,0.991,1425.4968,655.507)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.974,0.226,-0.226,0.974,1418.0496,695.9452)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.95,0.313,-0.313,0.95,1406.9561,735.5387)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.917,0.398,-0.398,0.917,1392.308,773.9594)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.877,0.48,-0.48,0.877,1374.2269,810.8888)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.83,0.558,-0.558,0.83,1352.8625,846.021)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.776,0.631,-0.631,0.776,1328.3919,879.0649)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.715,0.699,-0.699,0.715,1301.0178,909.7467)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.649,0.761,-0.761,0.649,1270.9671,937.8121)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.577,0.817,-0.817,0.577,1238.4888,963.0286)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.5,0.866,-0.866,0.5,1203.852,985.1871)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.419,0.908,-0.908,0.419,1167.3437,1004.1042)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.335,0.942,-0.942,0.335,1129.2665,1019.623)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.248,0.969,-0.969,0.248,1089.9358,1031.615)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.159,0.987,-0.987,0.159,1049.6775,1039.9808)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.068,0.998,-0.998,0.068,1008.8254,1044.651)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.023,-1,1,0.023,967.7178,1045.587)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.114,-0.994,0.994,0.114,926.6954,1042.7809)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.203,-0.979,0.979,0.203,886.0981,1036.2562)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.292,-0.957,0.957,0.292,846.2624,1026.0668)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.377,-0.926,0.926,0.377,807.5182,1012.2971)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.46,-0.888,0.888,0.46,770.1868,995.0613)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.539,-0.842,0.842,0.539,734.5773,974.5022)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.613,-0.79,0.79,0.613,700.985,950.7901)"
      fill="black"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.683,-0.731,0.731,0.683,669.688,924.1215)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.746,-0.666,0.666,0.746,640.9458,894.7175)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.804,-0.595,0.595,0.804,614.9966,862.8216)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.854,-0.52,0.52,0.854,592.0553,828.6981)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.898,-0.44,0.44,0.898,572.3121,792.6299)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.934,-0.356,0.356,0.934,555.9306,754.9158)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.963,-0.27,0.27,0.963,543.0464,715.8683)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.983,-0.181,0.181,0.983,533.7664,675.8109)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.996,-0.091,0.091,0.996,528.1675,635.0756)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="translate(526.296 594)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.996,0.091,-0.091,0.996,528.1675,552.9244)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.983,0.181,-0.181,0.983,533.7664,512.1891)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.963,0.27,-0.27,0.963,543.0464,472.1317)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.934,0.356,-0.356,0.934,555.9306,433.0842)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.898,0.44,-0.44,0.898,572.3121,395.3701)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.854,0.52,-0.52,0.854,592.0553,359.3019)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.804,0.595,-0.595,0.804,614.9966,325.1784)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.746,0.666,-0.666,0.746,640.9458,293.2825)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.683,0.731,-0.731,0.683,669.688,263.8785)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.613,0.79,-0.79,0.613,700.985,237.2099)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.539,0.842,-0.842,0.539,734.5773,213.4978)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.46,0.888,-0.888,0.46,770.1868,192.9387)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.377,0.926,-0.926,0.377,807.5182,175.7029)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.292,0.957,-0.957,0.292,846.2624,161.9332)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.203,0.979,-0.979,0.203,886.0981,151.7438)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.114,0.994,-0.994,0.114,926.6954,145.2191)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="end"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.023,1,-1,0.023,967.7178,142.413)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.068,-0.998,0.998,0.068,1008.8254,143.349)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.159,-0.987,0.987,0.159,1049.6775,148.0192)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.248,-0.969,0.969,0.248,1089.9358,156.385)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.335,-0.942,0.942,0.335,1129.2665,168.377)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.419,-0.908,0.908,0.419,1167.3437,183.8958)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.5,-0.866,0.866,0.5,1203.852,202.8129)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.577,-0.817,0.817,0.577,1238.4888,224.9714)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.649,-0.761,0.761,0.649,1270.9671,250.1879)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.715,-0.699,0.699,0.715,1301.0178,278.2533)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.776,-0.631,0.631,0.776,1328.3919,308.9351)"
      fill="rgb(80,90,120)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.83,-0.558,0.558,0.83,1352.8625,341.979)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.877,-0.48,0.48,0.877,1374.2269,377.1112)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.917,-0.398,0.398,0.917,1392.308,414.0406)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.95,-0.313,0.313,0.95,1406.9561,452.4613)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.974,-0.226,0.226,0.974,1418.0496,492.0548)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.991,-0.136,0.136,0.991,1425.4968,532.493)"

    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <text
      dominantBaseline="central"
      textAnchor="start"
      style={{
        stroke: "currentColor",
        strokeWidth: 4,
        fontStretch: "150%",
        fontSize: "4px"
      }}
      transform="matrix(0.999,-0.046,0.046,0.999,1429.2359,573.4409)"
    >
      ☐☐☐☐☐☐☐☐☐☐
    </text>
    <path
      d="M-5 -5l10 0l0 10l-10 0Z"
      transform="translate(1951 5)"
      fill="rgb(0,0,0)"
      fillOpacity={0}
      stroke="#ccc"
      strokeWidth={0}
      className="zr25-cls-2"
    />
  </svg>

export const graphIcon =
  <svg
    width={28}
    height={28}
    x="0px"
    y="0px"
    viewBox="0 0 256 256"
    enableBackground="new 0 0 256 256"
    xmlSpace="preserve"
    style={{
      transition: "all 0s"
    }}
  >
    <g>
      <g>
        <g>
          <path
            fill="currentColor"
            d="M174,6.5c-7.5,1.7-15.5,7.1-19.9,13.4c-4,6.1-5.6,11.4-5.6,19.5v5.4l-39.1,23.6C87.9,81.4,69.7,92.2,69,92.5c-1,0.4-1.8,0.4-2.8,0c-0.8-0.3-3.4-1.4-5.8-2.4c-17.9-7.4-38,0.3-46.6,17.8c-2.6,5.4-3.8,10-3.8,16c0,6,1.1,10.6,3.8,16c10,20.2,35.4,26.8,53.7,14c2-1.4,3.9-2.5,4.1-2.5c0.3,0,21,11.8,46,26.2c30.6,17.6,45.7,26.6,46.3,27.5c0.6,0.9,0.9,3.1,1.1,6.8c0.7,14.7,9.3,27.5,22.5,34c5.6,2.7,9.7,3.8,15.6,4.2c18.9,1.2,36.8-11.7,41.8-30.3c1.5-5.6,1.5-15.1,0-20.7c-3.4-12.4-13.4-23.5-25.3-27.8c-12.7-4.6-25.7-3.1-37.3,4.6c-2.5,1.6-3.5,2-4.5,1.7c-1.5-0.4-93.4-45.9-94.1-46.6c-0.3-0.3-0.6-3.2-0.6-6.5c0-3.3-0.4-7.3-0.8-8.9c-0.6-2.5-0.6-3.1,0-3.7c1.2-1.2,73.4-48.2,74.9-48.8c1.2-0.5,1.7-0.3,4.6,1.6c7.2,4.7,13.4,6.5,21,6.1c8.1-0.5,15.1-3.6,20.9-9.3c3.8-3.8,6.4-7.9,8.2-13.2c1.2-3.5,1.4-4.9,1.4-9.9c0-5-0.2-6.4-1.4-9.9c-3.5-10.2-10.6-17.5-20.8-21C186.5,5.8,178.9,5.4,174,6.5z"
          />
        </g>
      </g>
    </g>
  </svg>


export const closeIcon =
  <svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
  </svg>



export const plusIconRound =
  <svg viewBox="0 0 34 34">
    <g transform="rotate(45) translate(12 -12)" >
      <path fill="white" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
    </g>
  </svg>

export const plusIcon =
  <svg
    width={12}
    height={12}
    viewBox="0 0 18 18"
    fill="none"
  >
    <g opacity="1" clipPath="url(#clip0_11_321)">
      <path
        d="M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_321">
        <rect width={18} height={18} fill="currentColor" />
      </clipPath>
    </defs>
  </svg>

export const loadingMultiverseD =
  <svg
    width={"100%"}
    height={"100%"}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    baseProfile="full"
    viewBox="0 0 1050 800"
  >
    {/* <rect width={1050} height={800} x={0} y={0} fill="red" /> */}
    <g transform="translate(-400, 0)">
      <path
        d="M1126.2679 135.5153Q1061.1759 319.2824 1213.8737 188.8282"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_11)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.943,0.334,-0.334,0.943,1046.7573,160.5104)"
        fill="url(#c_gr_11)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.65,0.76,-0.76,0.65,1127.3547,209.5582)"
        fill="url(#c_gr_11)"
        fillOpacity="0.85"
      />
      <path
        d="M1128.5424 136.2389Q1077.1402 351.7235 1297.8957 370.2378"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.973,0.232,-0.232,0.973,1048.8499,161.1761)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(-0.084,0.997,-0.997,-0.084,1204.6549,376.455)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M1215.3088 190.3019Q1077.3221 341.6756 1254.3535 223.0355"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.739,0.674,-0.674,0.739,1128.6749,210.9141)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.557,0.831,-0.831,0.557,1164.5961,241.0289)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M1212.6742 187.3016Q1007.1482 326.7862 848.3511 132.0634"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_7)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.562,0.827,-0.827,0.562,1126.2511,208.1538)"
        fill="url(#c_gr_7)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.775,-0.632,0.632,0.775,791.0738,157.3346)"
        fill="url(#c_gr_7)"
        fillOpacity="0.85"
      />
      <path
        d="M775.2667 186.6201Q1004.5387 350.0615 1272.8473 268.817"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.58,-0.814,0.814,0.58,723.8362,207.5267)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.29,0.957,-0.957,0.29,1181.6103,283.148)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M775.0221 186.9452Q1006.9341 364.7229 1297.8557 371.421"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.608,-0.794,0.794,0.608,723.6112,207.8258)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(-0.023,1,-1,-0.023,1204.6181,377.5436)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M681.4315 399.8825Q898.5788 399.311 685.6274 356.8246"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_3)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(-0.003,-1,1,-0.003,637.5079,403.7282)"
        fill="url(#c_gr_3)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.196,-0.981,0.981,0.196,641.3681,364.1149)"
        fill="url(#c_gr_3)"
        fillOpacity="0.85"
      />
      <path
        d="M941.995 105.5417Q1038.8487 348.6486 1297.902 370.132"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.929,-0.37,0.37,0.929,877.2263,132.9347)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(-0.083,0.997,-0.997,-0.083,1204.6607,376.3577)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M721.3802 272.2582Q934.5817 434.9113 896.2786 700.3238"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_8)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.607,-0.795,0.795,0.607,674.2606,286.3139)"
        fill="url(#c_gr_8)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(-0.99,-0.143,0.143,-0.99,835.1672,680.1342)"
        fill="url(#c_gr_8)"
        fillOpacity="0.85"
      />
      <path
        d="M942.097 105.5026Q1035.1885 333.533 1272.7293 268.4314"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.926,-0.378,0.378,0.926,877.3201,132.8987)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(0.264,0.964,-0.964,0.264,1181.5018,282.7932)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M896.1196 700.2988Q928.7218 453.5227 681.2312 401.9269"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_10)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(-0.991,-0.131,0.131,-0.991,835.0209,680.1112)"
        fill="url(#c_gr_10)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(0.204,-0.979,0.979,0.204,637.3236,405.6091)"
        fill="url(#c_gr_10)"
        fillOpacity="0.85"
      />
      <path
        d="M1216.6587 191.4343Q1091.1334 362.0698 1297.8596 371.1686"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.806,0.593,-0.593,0.806,1129.9169,211.9559)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(-0.044,0.999,-0.999,-0.044,1204.6217,377.3114)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M1255.1922 224.119Q1093.6754 368.9791 1297.8546 371.8342"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.668,0.744,-0.744,0.668,1165.3677,242.0258)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(-0.014,1,-1,-0.014,1204.6171,377.9237)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M1077.3837 102.3008Q1055.0973 334.4557 1272.8693 268.8866"
        transform="matrix(0.92,0,0,0.92,10.5909,35.8363)"
        fill="none"
        stroke="url(#c_gr_5)"
        strokeWidth="1.0869565217391304"
        strokeOpacity="0.85"
      />
      <path
        d="M0 0L4 6L0 4.5L-4 6L0 0Z"
        transform="matrix(0.995,0.096,-0.096,0.995,1001.7838,129.953)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M0 0L0.6667 1L0 0.75L-0.6667 1L0 0Z"
        transform="matrix(0.288,0.958,-0.958,0.288,1181.6306,283.212)"
        fill="url(#c_gr_5)"
        fillOpacity="0.85"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1229.0525,432.9574)"
        fill="url(#c_gr_6)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1223.2947,474.2401)"
        fill="url(#c_gr_3)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1211.8895,514.3317)"
        fill="url(#c_gr_7)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1195.0555,552.4634)"
        fill="url(#c_gr_11)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1173.1155,587.9042)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1146.4902,619.9745)"
        fill="url(#c_gr_7)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1115.6901,648.0595)"
        fill="url(#c_gr_2)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1081.3057,671.6206)"
        fill="url(#c_gr_9)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1043.9963,690.2061)"
        fill="url(#c_gr_2)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1004.4772,703.4597)"
        fill="url(#c_gr_9)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,963.5062,711.1272)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,921.8689,713.0616)"
        fill="url(#c_gr_7)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,880.3634,709.2259)"
        fill="url(#c_gr_9)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(17.395,0,0,17.395,832.4225,697.3115)"
        fill="url(#c_gr_8)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,787.0756,677.7167)"
        fill="url(#c_gr_9)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,751.7449,655.6)"
        fill="url(#c_gr_12)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,719.8079,628.8149)"
        fill="url(#c_gr_11)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,691.8771,597.8749)"
        fill="url(#c_gr_11)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,668.488,563.3733)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,650.089,525.9715)"
        fill="url(#c_gr_11)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,637.033,486.3868)"
        fill="url(#c_gr_9)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,629.5701,445.378)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,627.8437,403.7315)"
        fill="url(#c_gr_10)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,631.8866,362.2458)"
        fill="url(#c_gr_3)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,641.6215,321.7162)"
        fill="url(#c_gr_3)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(17.395,0,0,17.395,660.2727,275.9732)"
        fill="url(#c_gr_2)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,686.1541,233.8966)"
        fill="url(#c_gr_8)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(11.597,0,0,11.597,714.4522,200.7126)"
        fill="url(#c_gr_8)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,747.2482,171.9658)"
        fill="url(#c_gr_11)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(11.597,0,0,11.597,783.8539,148.2597)"
        fill="url(#c_gr_7)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,823.5008,130.0917)"
        fill="url(#c_gr_3)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(17.395,0,0,17.395,871.0434,116.6754)"
        fill="url(#c_gr_10)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,920.14,111.2155)"
        fill="url(#c_gr_3)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,961.7878,112.9106)"
        fill="url(#c_gr_8)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1002.8022,120.3426)"
        fill="url(#c_gr_2)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(23.194,0,0,23.194,1054.8255,138.7655)"
        fill="url(#c_gr_6)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1102.6111,166.3764)"
        fill="url(#c_gr_7)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(17.395,0,0,17.395,1140.461,198.1203)"
        fill="url(#c_gr_11)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1172.6095,235.6271)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(17.395,0,0,17.395,1198.1909,277.8869)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(9.664,0,0,9.664,1216.5162,323.7614)"
        fill="url(#c_gr_6)"
      />
      <path
        d="M1 0A1 1 0 1 1 1 -0.0001"
        transform="matrix(23.194,0,0,23.194,1227.8104,377.7824)"
        fill="url(#c_gr_5)"
      />
      <path
        d="M-5 -5l10 0l0 10l-10 0Z"
        transform="translate(1991 5)"
        fill="rgb(0,0,0)"
        fillOpacity={0}
        stroke="#ccc"
        strokeWidth={0}
      />
    </g>
  </svg>

const duration = "4";
const a_ar = [1,2,3,4,5];
const a_ks = a_ar.map( () => "0 .2 .5 1").join(";");
const a_va = "25;45;175;175;45;25";

export const loadingProgress =
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 200">
    <g transform="translate(0,30)">
    {[1,2,3,4,5].map((a,i)=>(
      <circle key={"circlezz-"+i} fill="currentColor" stroke="currentColor" strokeWidth="15" r="15" cx="35" cy="100" opacity={1-(i*0.2)} >
        <animate attributeName="cx" calcMode="spline" dur={duration} values={a_va} keySplines={a_ks} repeatCount="indefinite" begin={`${0+0.05*i}`}></animate>
      </circle>
    ))}
    </g>
    </svg>

export const APPF_designerIcon  = 
  <svg
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.77049 0C8.85019 8.88467e-06 8.92663 0.0317688 8.98299 0.0882948C9.03935 0.144821 9.07102 0.221484 9.07102 0.301424V1.03779H12.6236C12.6844 0.864411 12.7834 0.706993 12.9132 0.577215C13.0266 0.463262 13.1613 0.372855 13.3096 0.311167C13.4579 0.249478 13.6169 0.217717 13.7774 0.217701C13.938 0.217686 14.0969 0.249416 14.2452 0.311076C14.3935 0.372736 14.5283 0.463117 14.6417 0.577047C14.7553 0.690869 14.8454 0.826012 14.9068 0.974758C14.9683 1.1235 15 1.28294 15 1.44396C15 1.60497 14.9683 1.7644 14.9068 1.91314C14.8454 2.06188 14.7553 2.19702 14.6417 2.31084C14.5282 2.42507 14.3933 2.51572 14.2448 2.57759C14.0963 2.63946 13.937 2.67134 13.7762 2.6714C13.4515 2.6714 13.1398 2.54139 12.9108 2.31074L12.8888 2.28624C12.7694 2.16138 12.6781 2.01225 12.6211 1.84895L10.7887 1.84888C11.3797 2.19293 11.9166 2.62901 12.3768 3.13643C13.2947 4.15114 13.902 5.40935 14.1263 6.76086L14.6148 6.76099C14.8172 6.76092 14.9814 6.92557 14.9814 7.12852V8.78391C14.9814 8.98682 14.8172 9.15147 14.6148 9.15147H12.9937C12.7913 9.15147 12.6272 8.98682 12.6272 8.78387L12.6273 7.12852C12.6272 6.92557 12.7913 6.76092 12.9937 6.76092L13.3712 6.76099C13.1536 5.59971 12.6195 4.52159 11.8282 3.6462C11.09 2.82617 10.1335 2.23493 9.07133 1.9422V2.58914C9.07133 2.75577 8.93663 2.89093 8.77046 2.89157L6.51775 2.89164C6.4389 2.8897 6.36391 2.857 6.30871 2.80049C6.25352 2.74398 6.22247 2.66811 6.22216 2.58901V1.55869C5.13222 1.86081 3.7427 2.64478 3 3.5C2.24362 4.3638 1.71555 5.63568 1.5 6.76464H2.29209C2.49451 6.76464 2.65864 6.92926 2.65864 7.13224L2.65861 8.78391C2.65864 8.98682 2.49451 9.15147 2.29213 9.15147H0.662439C0.460089 9.15147 0.295958 8.98682 0.295958 8.78387L0.295891 7.12852C0.295958 6.92557 0.460089 6.76092 0.662472 6.76092L1.16332 6.76099C1.38748 5.44794 2.5 3.6462 2.8482 3.21863C5 1.5 4.87541 1.86217 5.5 1.5H2.37758C2.31658 1.67296 2.37758 2.08941 2.08199 2.31208C1.85291 2.54134 1.54253 2.67013 1.21891 2.67019C0.896461 2.67011 0.587104 2.54226 0.358196 2.31449C0.128908 2.0846 6.1157e-05 1.77278 0 1.44761C2.5266e-05 1.2866 0.0316779 1.12718 0.0931496 0.978442C0.154621 0.829707 0.244708 0.694575 0.358263 0.580767C0.471748 0.466884 0.606488 0.376536 0.754789 0.314883C0.90309 0.25323 1.06205 0.221479 1.22258 0.221444C1.38312 0.221472 1.54208 0.25322 1.69038 0.314873C1.83868 0.376526 1.97342 0.466878 2.0869 0.580767C2.2178 0.710372 2.31721 0.868395 2.37758 1.04265L6.22216 1.04269V0.307522V0.302563C6.22217 0.223369 6.25313 0.147334 6.3084 0.0907749C6.36367 0.0342154 6.43884 0.00163808 6.51778 3.35064e-05L8.77049 0Z"
      fill="currentColor"
    />
   
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10.4583L6.11111 14H8.88889L10 10.4583L7.59259 4V9.83333C8.0456 10.0304 8.13745 10.4569 7.77778 10.875C7.51061 11.1856 7.59259 11.2917 7.22222 10.875C6.86841 10.4637 6.97213 10.0084 7.40741 9.83333V4L5 10.4583Z"
      fill="#C12A0C"
    />
  </svg>



export function DialogLogo(){
  return (<svg
      style={{
        position: "absolute",
        top:5,
        left:10,
        marginLeft:"calc(100% - 52.42px)",
        opacity:0.124,
      }}
      viewBox="0 0 36 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={32.42}
      height={32.42}
    >
  <path
    d="M33.0083 8.85659L32.6651 8.66629L17.0023 0L1.33774 8.66629L0.994523 8.85659L0 9.40742V19.8389L9.32568 24.9983L17.0006 20.7519L24.6755 25L34.0029 19.8389V11.0009V9.40742L33.0067 8.85659H33.0083ZM17.0023 3.07573L29.8858 10.2042L24.6788 13.0862L17.0023 8.83977L9.32568 13.0862L4.11871 10.2042L17.0023 3.07573ZM24.6771 21.9242L17.0023 17.6762L9.32735 21.9242L2.68052 18.2455V12.4832L9.32735 16.1602L17.0039 11.9139L24.6805 16.1602L31.3273 12.4814V18.2439L24.6805 21.9226L24.6771 21.9242Z"
    fill="#FFF"
  />
</svg>)}


export const APPF_securityBlast = ({width=24})=>{
  return    <svg
  enableBackground="new 0 0 24 24"
  height={`${width}px`}
  viewBox="0 0 24 24"
  width={`${width}px`}
  fill="currentColor"
>
  <g>
    <path d="M0,0h24v24H0V0z" fill="none" />
  </g>
  <g>
    <g>
      <path d="M6,13c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S6.55,13,6,13z M6,17c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1 S6.55,17,6,17z M6,9c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S6.55,9,6,9z M3,9.5c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5 s0.5-0.22,0.5-0.5S3.28,9.5,3,9.5z M6,5C5.45,5,5,5.45,5,6s0.45,1,1,1s1-0.45,1-1S6.55,5,6,5z M21,10.5c0.28,0,0.5-0.22,0.5-0.5 S21.28,9.5,21,9.5s-0.5,0.22-0.5,0.5S20.72,10.5,21,10.5z M14,7c0.55,0,1-0.45,1-1s-0.45-1-1-1s-1,0.45-1,1S13.45,7,14,7z M14,3.5 c0.28,0,0.5-0.22,0.5-0.5S14.28,2.5,14,2.5S13.5,2.72,13.5,3S13.72,3.5,14,3.5z M3,13.5c-0.28,0-0.5,0.22-0.5,0.5 s0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5S3.28,13.5,3,13.5z M10,20.5c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5 S10.28,20.5,10,20.5z M10,3.5c0.28,0,0.5-0.22,0.5-0.5S10.28,2.5,10,2.5S9.5,2.72,9.5,3S9.72,3.5,10,3.5z M10,7c0.55,0,1-0.45,1-1 s-0.45-1-1-1S9,5.45,9,6S9.45,7,10,7z M10,12.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5S10.83,12.5,10,12.5z M18,13c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S18.55,13,18,13z M18,17c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1 S18.55,17,18,17z M18,9c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S18.55,9,18,9z M18,5c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1 S18.55,5,18,5z M21,13.5c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5S21.28,13.5,21,13.5z M14,17 c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S14.55,17,14,17z M14,20.5c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5s0.5-0.22,0.5-0.5 S14.28,20.5,14,20.5z M10,8.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5S10.83,8.5,10,8.5z M10,17 c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S10.55,17,10,17z M14,12.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5 S14.83,12.5,14,12.5z M14,8.5c-0.83,0-1.5,0.67-1.5,1.5s0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5S14.83,8.5,14,8.5z" />
    </g>
  </g>
</svg>
}

export const SSS_ = 
( new Date().getUTCFullYear()=="2025" &&  (window.location.origin.indexOf("ev.appfactor")!=-1 || window.location.origin.indexOf("42.appfactor")!=-1 ) )
?
<svg
style={{
    marginLeft:-40,
    marginTop:-25,
    position:"absolute",
    filter: " sepia(22%) "
}}
width={68}
height={53}
viewBox="0 0 78 63"
fill="none"
xmlns="http://www.w3.org/2000/svg"
xmlnsXlink="http://www.w3.org/1999/xlink"
>
<rect width={78} height={63} fill="url(#pattern0_26_37)" />
<defs>
  <pattern
    id="pattern0_26_37"
    patternContentUnits="objectBoundingBox"
    width={1}
    height={1}
  >
    <use
      xlinkHref="#image0_26_37"
      transform="matrix(0.005 0 0 0.00619048 0 -0.00142857)"
    />
  </pattern>
  <image
    id="image0_26_37"
    width={200}
    height={162}
    preserveAspectRatio="none"
    xlinkHref="data:image/png;base64,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"
  />
</defs>
</svg>:<></>


export const APPF_deployIcon = 
<svg
  viewBox="0 0 34 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clipPath="url(#clip0_7530_5241)">
    <path
      d="M10 9H24V11H10V9ZM10 19H14V25H20V19H24L17 12L10 19ZM18 17V23H16V17H14.83L17 14.83L19.17 17H18Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_7530_5241">
      <rect width={24} height={24} fill="currentColor" transform="translate(5 5)" />
    </clipPath>
  </defs>
</svg>



export const APPF_ICONS = {
  APPF_dashboardIcon,
  APPF_radarIcon,
  APPF_discoveryIcon,
  APPF_waveIcon,
  APPF_factorIcon,
  APPF_multiverseIcon,
  APPF_aiIcon,
  APPF_refreshIcon,
  menuTogleIcon,
  APPF_bitBucket,
  APPF_gitLab,
  APPF_gitHub,
  APPF_appsIcon,
  APPF_designerIcon,
  APPF_deployIcon,
  APPF_securityBlast
}

